export const loadLottie = require('bundle-loader?lazy&name=[name]!lottie-web/build/player/lottie_light.min');
export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
